<template>

</template>

<script setup lang="ts">
import type {  IMatch } from "~src/interfaces";

interface IProps {
  match: IMatch;
}

const props = withDefaults(defineProps<IProps>(), {});
</script>

<script lang="ts">
export default {};
</script>
